import {
    isFlagUnderPrefix,
    useClearNotificationFlagsOnLeave,
} from '../../custom-hooks/useClearNotificationFlagsOnLeave';

export interface ClearNotificationFlagsOnLeaveProps {
    prefixes: string[];
}

export const ClearNotificationFlagsOnLeave = (
    props: ClearNotificationFlagsOnLeaveProps
): null => {
    useClearNotificationFlagsOnLeave(
        (eventCode) =>
            props.prefixes.some((prefix) => isFlagUnderPrefix(eventCode, prefix)),
        props.prefixes.join('|')
    );
    return null;
};
